var map = {
	"./29_car.mp3": "f419",
	"./30_doll.mp3": "1311",
	"./31_ball.mp3": "1558",
	"./32_robot.mp3": "97e8e",
	"./33_one.mp3": "7196",
	"./34_two.mp3": "fd2f",
	"./35_three.mp3": "eb8a",
	"./36_sing.mp3": "2519",
	"./37_catch.mp3": "40f4",
	"./38_clap.mp3": "47d0",
	"./39_dance.mp3": "e3c9",
	"./40_run.mp3": "3afb",
	"./41_paint.mp3": "b09f",
	"./42_jump.mp3": "2e317"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b0b";